<div>
	<div class="calendar-days">
		<div class="day-header"></div>
		@for (date of daysOfWeek(); track date.format) {
			<div class="day-header">
				{{ date.format }}
			</div>
		}
	</div>

	<div class="calendar-scroll-container">
		<div class="calendar-body">
			<div class="calendar-column"></div>
			@for (day of daysOfWeek(); track day.format; let index = $index; let last = $last) {
				<div
					class="calendar-column"
					[ngStyle]="{ 'grid-column': index + 2 }"
					[ngClass]="{ 'last-column': $last }"
					[attr.data-day-of-week]="day.format"
				></div>
			}

			@for (time of timesOfDay(); track time.id; let timeIndex = $index; let lastTime = $last) {
				@for (day of daysOfWeek(); track day.format; let dayIndex = $index) {
					<div
						class="calendar-cell"
						[ngStyle]="{ 'grid-row': timeIndex + 1, 'grid-column': dayIndex + 2 }"
						[ngClass]="{
							dashed: timeIndex % 2 !== 0,
							selected: isTimeSlotSelected(dayIndex, time.id),
							preferred: isPreferredTimeSlot(dayIndex, time.id),
							disableCell:
								(disableCalendar() && !isTimeSlotSelected(dayIndex, time.id)) ||
								(daySelected(dayIndex) && !isTimeSlotSelected(dayIndex, time.id))
						}"
						[attr.data-grid-row]="timeIndex + 1"
						[attr.data-day-of-week]="day.format"
						[attr.data-hour-of-day]="time.hour"
						[attr.data-minute-of-hour]="time.minute"
						(mousedown)="onCellDragStart($event, dayIndex, time.id)"
						(mouseenter)="onCellDragEnter($event, dayIndex, time.id)"
						(mouseleave)="onCellDragExit($event, dayIndex, time.id)"
						(mouseup)="onCellDragEnd($event)"
					></div>
				}
			}

			@for (time of timesOfDay(); track time.id; let index = $index; let last = $last) {
				<div [id]="'time-' + time.id" class="time-cell" [ngStyle]="{ 'grid-row': index + 1 }">{{ $odd ? '' : time.label }}</div>
			}
		</div>
	</div>
</div>
